// types
import { ConfigStates } from 'types/config';

export const DASHBOARD_PATH = '/dashboard';
// Entries shown on the horizontal menu bar before the rest move into a "More items" dropdown, by
// screen width. Below md the layout always falls back to the vertical drawer, so md is the smallest.
export const HORIZONTAL_MAX_ITEMS = {
  md: 5,
  lg: 7,
  xl: 9
} as const;

// A picker with more options than this switches from a plain dropdown to a searchable autocomplete.
// Applies to the header's company and site selectors.
export const MAX_ITEMS_FOR_SELECT = 20;

// The tenant picker crosses over sooner — it sits leftmost in the header where space is tightest.
export const MAX_TENANTS_FOR_SELECT = 5;

// Characters in the site key generated for a new site. The key is the only unguessable part of the
// device enrolment code ({TenantId}-{SiteId}-{SiteKey}), which is an unauthenticated credential, so
// this length is the code's whole security margin. Alphanumeric, so 12 gives ~62 bits — enough that
// brute force stays impractical without relying on rate limiting or a small number of sites.
export const SITE_KEY_LENGTH = 12;

export const CSS_VAR_PREFIX = '';

export enum MenuOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal'
}

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system'
}

export enum ThemeDirection {
  LTR = 'ltr',
  RTL = 'rtl'
}

export enum AuthProvider {
  AUTH0 = 'auth0'
}

export enum DropzopType {
  default = 'DEFAULT',
  standard = 'STANDARD'
}

export const APP_AUTH: AuthProvider = AuthProvider.AUTH0;
// Light theme is the default for the Weightrax PoC. Dark theme polish deferred — see THEME-SPEC.md §1.
export const DEFAULT_THEME_MODE: ThemeMode = ThemeMode.LIGHT;

const config: ConfigStates = {
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: false,
  // Inter for SaaS density. Heebo reserved for the kiosk. See THEME-SPEC.md §2.
  fontFamily: `'Inter', sans-serif`,
  // 8px default radius matches THEME-SPEC.md §4 (radius.md).
  borderRadius: 8,
  outlinedFilled: true,
  // Weightrax brand preset — palette defined in src/themes/theme/weightrax.js, mapped via src/themes/palette.jsx.
  presetColor: 'weightrax',
  i18n: 'en',
  themeDirection: ThemeDirection.LTR,
  // Fluid content per Path B Figma (2026-05-09): false = full-width content, no max-width Container wrap.
  container: false
};

export default config;
